import { getCountriesTargetFromAdTargetingSubmission } from '../../common/adTargeting/targetingTermValueSelectors';
import type { TargetingTermValue } from '../../models';

export function getAdCountryListForReview(
  lineItemCountries: (string | null | undefined)[] | null | undefined,
  targetingTermValues: TargetingTermValue[]
): string[] {
  const filteredLineItemCountries = (lineItemCountries ?? []).reduce<string[]>((countries, country) => {
    if (country) {
      countries.push(country);
    }
    return countries;
  }, []);

  return getCountriesTargetFromAdTargetingSubmission(targetingTermValues, filteredLineItemCountries);
}
